import React from 'react'
import './Contact.css'
const Contact = () => {
  return (
   <section id='contactPage'>
    <div id='contact'>
        <h1 className='contactPageTitle'>Contact Us</h1>
        <span className='contactDesc'>To contact us please fill the following detail</span>
        <form className='contactForm'>
            <input type='text' className='name' placeholder='Your name'></input>
            <input type='email' className='email' placeholder='Your email'></input>
            <textarea className='msg' name='message' rows='5' placeholder='Your message'></textarea>
            <button type='submit' value='send' className='submitBtn'>submit</button>
        </form>

    </div>
   </section>
  )
}

export default Contact
